import { render, staticRenderFns } from "./ReferenceEditModal.vue?vue&type=template&id=e863b00e&"
import script from "./ReferenceEditModal.vue?vue&type=script&lang=js&"
export * from "./ReferenceEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports